const roles = {
  assembleAdmin: 1,
  superAdmin: 2,
  stateAdmin: 3,
  associationAdmin: 4,
  clubAdmin: 5,
  teamAdmin: 6,
  appointmentBoardAdmin: 101,
  // eventTeamAdmin: 999,
  matchDayAdmin: 1001,
  compAdmin: 1002,
};

const roleLevels = {
  1: 'assemble',
  2: 'nationals',
  3: 'states',
  4: 'associations',
  5: 'clubs',
  6: 'teams',
  101: 'appointmentBoard',
  1001: 'matchDay',
  1002: 'compAdmin',
};

const getRoleName = (type, key) => {
  switch (type) {
    case 1: return 'Assemble Admin';
    case 2: return 'Super Admin';
    case 3: return 'State Admin';
    case 4: return 'Association Admin';
    case 5: return 'Club Admin';
    case 6: return 'Team Admin';
    case 101: return 'Appointment Board Admin';
    // case 999: return 'Event Team Admin';
    case 1001: return 'Match Day Admin';
    case 1002: return 'Competition Admin';
    default: return '';
  }
};

module.exports = {
  roles,
  getRoleName,
  roleLevels,
};
